import ProjectHelper from 'src/app/helpers/project-helper';
import { BaseProject } from 'src/app/model/project/base-project';

export class EditIPAdjustmentHelper {
  // would normally make sense to pass adjustment as parameter, but the BaseProject
  // having an address is currently the only limiting factor
  static verifyApproval(baseProject: BaseProject): string {
    if (!ProjectHelper.hasApprovableAddress(baseProject)) {
      return 'Gelieve voor de originele plaatsing het adres in te vullen';
    }
    return null;
  }
}
